

<!-- !PAGE CONTENT! -->
<div class="w3-content" style="max-width:1500px">

  <!-- Header -->
  <div class="w3-opacity">
  <header class="w3-center w3-margin-bottom">
    <h1><b>PHOTOLIO</b></h1>
  </header>
  </div>
  
  <!-- Photo Grid -->
  <div class="w3-row w3-row-padding" id="myGrid" style="margin-bottom:128px">
    <div class="w3-third">
      <img src="/assets/img/2.jpg" style="width:100%">
      <img src="/assets/img/3.jpg" style="width:100%">
      <img src="/assets/img/5.jpg" style="width:100%">
      <img src="/assets/img/6.jpg" style="width:100%">
      <img src="/assets/img/7.png" style="width:100%">
    
    </div>
  
    <div class="w3-third">
      <img src="/assets/img/10.jpg" style="width:100%">
      <img src="/assets/img/12.jpg" style="width:100%">
      <img src="/assets/img/13.jpg" style="width:100%">
      <img src="/assets/img/14.jpg" style="width:100%">
      <img src="/assets/img/15.jpg" style="width:100%">
      <img src="/assets/img/16.jpg" style="width:100%">
      <!-- <img src="/assets/img/amazing.jpg" style="width:100%"> -->
    </div>
  
    <div class="w3-third">
      <img src="/assets/img/17.jpg" style="width:100%">
      <img src="/assets/img/18.jpg" style="width:100%">
      <img src="/assets/img/19.jpg" style="width:100%">
      <img src="/assets/img/20.jpg" style="width:100%">
      <img src="/assets/img/2.jpg" style="width:100%">
    </div>
  </div>
</div>
